import gql from "graphql-tag";
import MovieFragment from "graphql/Media/Movie/fragment/MovieFragment";

export default gql`

  ${MovieFragment}

  fragment CollectionFragment on Collection {
    id
    name
    additionDate
    tmdbOptions
    status
    Movie {
      ...MovieFragment
    }
  }

`
